export default "__VITE_ASSET__4f0af892__"